"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _MasterOutput = _interopRequireDefault(require("./MasterOutput"));

var _SocialIteration = _interopRequireDefault(require("./SocialIteration"));

var _NewOutput = _interopRequireDefault(require("./NewOutput"));

var _newOutput = _interopRequireDefault(require("../../../../../common/constants/newOutput"));

var _getDefaultDuration = _interopRequireDefault(require("../utils/getDefaultDuration"));

require("../styles/_outputs-and-addons.scss");

var _Footer = _interopRequireDefault(require("../../../components/Footer"));

var _CostFooter = _interopRequireDefault(require("./CostFooter"));

var _utils = require("../../../utils");

var _MissingFieldsModal = _interopRequireDefault(require("./MissingFieldsModal"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function hasAnyOutputWithCost(_ref) {
  var getAddonsCost = _ref.getAddonsCost,
      outputs = _ref.outputs;

  if (outputs.length > 1) {
    return true;
  }

  return outputs.reduce(function (hasCost, _ref2) {
    var versions = _ref2.versions;
    return Boolean(getAddonsCost(versions[0].appliedAddons, {
      numberValue: true
    }));
  }, false);
}

function scrollToNewestOutput() {
  var scrollable = document.querySelector('.outputs-and-addons');

  if (!scrollable) {
    return;
  }

  scrollable.scroll({
    top: scrollable.scrollHeight,
    behavior: 'smooth'
  });
}

var OutputsAndAddons = /*#__PURE__*/function (_Component) {
  _inherits(OutputsAndAddons, _Component);

  var _super = _createSuper(OutputsAndAddons);

  function OutputsAndAddons(props) {
    var _this;

    _classCallCheck(this, OutputsAndAddons);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onSave", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, onSaveOutputs, hasUpdatePermission, outputs, _yield$onSaveOutputs, error, savedOutputs;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, onSaveOutputs = _this$props.onSaveOutputs, hasUpdatePermission = _this$props.hasUpdatePermission;
              outputs = _this.state.outputs;

              if (hasUpdatePermission) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              _context.next = 6;
              return onSaveOutputs(outputs);

            case 6:
              _yield$onSaveOutputs = _context.sent;
              error = _yield$onSaveOutputs.error;
              savedOutputs = _yield$onSaveOutputs.outputs;

              if (!error) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return");

            case 11:
              _this.setState({
                outputs: savedOutputs
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "mergeAddon", function (outputId, addonType, addonValue) {
      var outputs = _this.state.outputs;
      var outputIndex = outputs.findIndex(function (output) {
        return output.outputId === outputId;
      });
      var existingOutput = outputs[outputIndex];
      var version = existingOutput.versions[0];

      var newAddons = _objectSpread(_objectSpread({}, version.appliedAddons), {}, _defineProperty({}, addonType, addonValue));

      var newVersion = _objectSpread(_objectSpread({}, version), {}, {
        appliedAddons: newAddons
      });

      var newOutput = _objectSpread(_objectSpread({}, existingOutput), {}, {
        versions: [newVersion]
      });

      var newOutputs = _toConsumableArray(outputs);

      newOutputs.splice(outputIndex, 1, newOutput);

      _this.setState({
        outputs: newOutputs
      }, _this.onSave);
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeAddon", function (outputId) {
      return function (field) {
        return function (addonValue) {
          if (field === 'aspectRatio') {
            var outputs = _this.state.outputs;
            var outputIndex = outputs.findIndex(function (output) {
              return output.outputId === outputId;
            });

            var newOutput = _objectSpread(_objectSpread({}, outputs[outputIndex]), {}, {
              aspectRatio: addonValue.value
            });

            var newOutputs = _toConsumableArray(outputs);

            newOutputs.splice(outputIndex, 1, newOutput);
            return void _this.setState({
              outputs: newOutputs
            }, _this.onSave);
          }

          _this.mergeAddon(outputId, field, addonValue);
        };
      };
    });

    _defineProperty(_assertThisInitialized(_this), "updateOutputName", function (outputId) {
      return function (_ref4) {
        var value = _ref4.target.value;
        var outputs = _this.state.outputs;
        var outputIndex = outputs.findIndex(function (output) {
          return output.outputId === outputId;
        });

        var newOutput = _objectSpread(_objectSpread({}, outputs[outputIndex]), {}, {
          name: value
        });

        var newOutputs = _toConsumableArray(outputs);

        newOutputs.splice(outputIndex, 1, newOutput);
        return void _this.setState({
          outputs: newOutputs
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "createNewOutput", function () {
      var currentOutputs = _this.state.outputs;
      var _this$props2 = _this.props,
          video = _this$props2.video,
          additionalOutputCost = _this$props2.additionalOutputCost;
      var newOutputs = [].concat(_toConsumableArray(currentOutputs), [(0, _newOutput.default)({
        video: video,
        outputCost: additionalOutputCost,
        defaultDuration: (0, _getDefaultDuration.default)(video.clips)
      })]);

      _this.setState({
        outputs: newOutputs
      }, function () {
        _this.onSave();

        scrollToNewestOutput();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "deleteOutput", function (index) {
      return function () {
        var outputs = _this.state.outputs;

        var newOutputs = _toConsumableArray(outputs); // Master is at 0, so we count from 1


        newOutputs.splice(index + 1, 1);

        _this.setState({
          outputs: newOutputs
        }, _this.onSave);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleNotesChange", function (outputId, notes) {
      _this.setState(function (_ref5) {
        var prevOutputs = _ref5.outputs;
        var outputs = prevOutputs.map(function (item) {
          if (item.outputId === outputId) {
            return _objectSpread(_objectSpread({}, item), {}, {
              notes: notes
            });
          }

          return item;
        });
        return {
          outputs: outputs
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleMissingFieldsModal", function () {
      _this.setState(function (_ref6) {
        var showMissingFields = _ref6.showMissingFields;
        return {
          showMissingFields: !showMissingFields
        };
      });
    });

    var _outputs = props.video.outputs;
    _this.state = {
      outputs: _outputs
    };
    return _this;
  }

  _createClass(OutputsAndAddons, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          outputs = _this$state.outputs,
          showMissingFields = _this$state.showMissingFields;
      var _this$props3 = this.props,
          goBack = _this$props3.goBack,
          _this$props3$video = _this$props3.video,
          assets = _this$props3$video.assetIds,
          notesToTheEditor = _this$props3$video.notesToTheEditor,
          clips = _this$props3$video.clips,
          video = _this$props3.video,
          hasUpdatePermission = _this$props3.hasUpdatePermission,
          shouldShowPendingApprovalInformation = _this$props3.shouldShowPendingApprovalInformation,
          shouldShowPendingApprovalButtons = _this$props3.shouldShowPendingApprovalButtons,
          getAddonsCost = _this$props3.getAddonsCost,
          getCurrencySymbol = _this$props3.getCurrencySymbol,
          openPaymentsInvoiceModal = _this$props3.openPaymentsInvoiceModal,
          costReviewEnabled = _this$props3.costReviewEnabled,
          hasCostApprovalPermission = _this$props3.hasCostApprovalPermission,
          canUpdateVideo = _this$props3.canUpdateVideo,
          goToNextStage = _this$props3.goToNextStage,
          history = _this$props3.history;
      var masterOutputIndex = outputs.findIndex(function (output) {
        return output.isMaster;
      });
      var masterOutput = outputs[masterOutputIndex];
      var canUpdateMaster = hasUpdatePermission && masterOutput.status.name === 'DRAFT';

      var additionalOutputs = _toConsumableArray(outputs);

      additionalOutputs.splice(masterOutputIndex, 1);
      var outputCost = getAddonsCost({}, {
        numberValue: true,
        isMaster: false
      });
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_MissingFieldsModal.default, {
        onClose: this.toggleMissingFieldsModal,
        visible: showMissingFields,
        notesToTheEditor: notesToTheEditor,
        clips: clips,
        history: history
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "outputs-and-addons column"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "outputs-and-addons__section"
      }, /*#__PURE__*/_react.default.createElement(_MasterOutput.default, _extends({}, masterOutput, {
        onChangeAddon: this.onChangeAddon(masterOutput.outputId),
        assets: assets,
        canUpdateOutput: canUpdateMaster
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "outputs-and-addons__section outputs-and-addons__social-iterations"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "outputs-and-addons__social-iterations__header"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "outputs-and-addons__social-iterations__header__titles"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        heading4: true
      }, "Social Iterations"), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        timestamp: true
      }, "The master iteration needs to be approved and signed off before any work can be done on any other additional iterations.")), hasUpdatePermission ? /*#__PURE__*/_react.default.createElement("div", {
        className: "outputs-and-addons__social-iterations__header__action"
      }, /*#__PURE__*/_react.default.createElement(_NewOutput.default, {
        onClick: this.createNewOutput
      }), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        heading5: true
      }, "from ".concat(getCurrencySymbol()).concat(outputCost, " each"))) : null), !additionalOutputs.length ? /*#__PURE__*/_react.default.createElement(_uiKit.Text, null, "No iterations have been added to this project.") : null, /*#__PURE__*/_react.default.createElement("div", null, additionalOutputs.map(function (output, index) {
        var canUpdateOutput = hasUpdatePermission && (output.status.name === 'DRAFT' || output.status.name === 'PENDING_MASTER');
        return /*#__PURE__*/_react.default.createElement(_SocialIteration.default, _extends({}, output, {
          onNotesChange: _this2.handleNotesChange,
          onBlurField: _this2.onSave,
          onChangeAddon: _this2.onChangeAddon(output.outputId),
          assets: assets,
          canUpdateOutput: canUpdateOutput,
          outputIndex: index,
          updateOutputName: _this2.updateOutputName,
          deleteOutput: _this2.deleteOutput(index)
        }));
      })), /*#__PURE__*/_react.default.createElement(_CostFooter.default, {
        cost: "".concat(getCurrencySymbol()).concat(outputCost * additionalOutputs.length)
      }))), /*#__PURE__*/_react.default.createElement(_Footer.default, {
        buttonText: !canUpdateVideo ? 'Continue' : costReviewEnabled && !hasCostApprovalPermission && hasAnyOutputWithCost({
          outputs: outputs,
          getAddonsCost: getAddonsCost
        }) ? 'Payment & Submit For Review' : 'Proceed To Payment',
        onBackClick: goBack,
        onNext: !canUpdateVideo ? goToNextStage : !(0, _utils.isValidBrief)(video) ? this.toggleMissingFieldsModal : hasUpdatePermission ? openPaymentsInvoiceModal : void 0,
        showBriefInformation: !shouldShowPendingApprovalInformation && !shouldShowPendingApprovalButtons
      }));
    }
  }]);

  return OutputsAndAddons;
}(_react.Component);

exports.default = OutputsAndAddons;